import { render, staticRenderFns } from "./FileGridItem.vue?vue&type=template&id=022fde24"
import script from "./FileGridItem.vue?vue&type=script&lang=js"
export * from "./FileGridItem.vue?vue&type=script&lang=js"
import style0 from "./FileGridItem.vue?vue&type=style&index=0&id=022fde24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports